<template>
	<div style="min-width:1200px;">
		<div class="unfind-content">
			<img src="../../assets/image/404.png">
			<a :href="CurrentEnvPrefix.main" class="unfind-refund"></a>
		</div>
	</div>
</template>

<style type="text/css" scoped>
	.unfind-content{background: #fff;position: relative;text-align: center;}
	.unfind-content img{width: 1000px;}
	.unfind-refund{position: absolute;width: 200px;height: 60px;display: inline-block;bottom: 34%;left: 52%;}
</style>

<script>
import {CurrentEnvPrefix} from 'config/urlprefix.js'
export default {
  	data () {
    	return {
				CurrentEnvPrefix
    	}
  	},
    methods: {
    },
    mounted(){
    },
  beforeRouteEnter(to, from, next){
    if(to.path === '/') {
      window.open(CurrentEnvPrefix.main)
    }else{
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/default/unfind.vue